import axios from "axios";
import { message } from "antd";

const baseConfig = {
  baseURL: "https://igraonicebl.com/api",
};
let isLoggedOut = false;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  service: (useAuth) => {
    const instance = axios.create(baseConfig);
    instance.defaults.headers.common["Content-Type"] = "application/json";

    if (useAuth) {
      instance.interceptors.request.use(
        async (config) => {
          const token = sessionStorage.getItem("token");
          if (token) {
            config.headers = {
              ...config.headers,
              Authorization: `Bearer ${token}`,
            };
          }
          return config;
        },
        (error) => {
          console.log("Error in request interception:", error);
          return Promise.reject(error);
        }
      );

      instance.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            if (!isLoggedOut) {
              isLoggedOut = true;
              message.error("Vaša sesija je istekla!");
              sessionStorage.removeItem("token");
              window.location.href = "/login";
            }
            return new Promise(() => {});
          }
          return Promise.reject(error);
        }
      );
    }

    return instance;
  },
};
